import { render, staticRenderFns } from "./ModalTrilha.vue?vue&type=template&id=5413d86b&scoped=true"
import script from "./ModalTrilha.vue?vue&type=script&lang=js"
export * from "./ModalTrilha.vue?vue&type=script&lang=js"
import style0 from "./ModalTrilha.vue?vue&type=style&index=0&id=5413d86b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413d86b",
  null
  
)

export default component.exports